/* eslint-disable */
import * as types from './graphql';
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

/**
 * Map of all GraphQL operations in the project.
 *
 * This map has several performance disadvantages:
 * 1. It is not tree-shakeable, so it will include all operations in the project.
 * 2. It is not minifiable, so the string of a GraphQL query will be multiple times inside the bundle.
 * 3. It does not support dead code elimination, so it will add unused operations.
 *
 * Therefore it is highly recommended to use the babel or swc plugin for production.
 */
const documents = {
    "\n  query ListInsuranceProviders {\n    allInsuranceProviders {\n      edges {\n        node {\n          id\n          slug\n          niceName\n          mcsPartner {\n            slug\n            niceName\n          }\n        }\n      }\n    }\n  }\n": types.ListInsuranceProvidersDocument,
    "\n  mutation SubmitIntakeForm($input: IntakeSubmitInputType!) {\n    intakeFormSubmit(input: $input) {\n      graphqlMemberId\n    }\n  }\n": types.SubmitIntakeFormDocument,
    "\n  mutation CreatePhiFileReference($input: CreatePhiFileReferenceInput!) {\n    phiFileReferenceCreate(input: $input) {\n      phiFileReference {\n        id\n        claimCode\n      }\n      s3UploadInfo {\n        uploadUrl\n      }\n    }\n  }\n": types.CreatePhiFileReferenceDocument,
};

/**
 * The graphql function is used to parse GraphQL queries into a document that can be used by GraphQL clients.
 *
 *
 * @example
 * ```ts
 * const query = graphql(`query GetUser($id: ID!) { user(id: $id) { name } }`);
 * ```
 *
 * The query argument is unknown!
 * Please regenerate the types.
 */
export function graphql(source: string): unknown;

/**
 * The graphql function is used to parse GraphQL queries into a document that can be used by GraphQL clients.
 */
export function graphql(source: "\n  query ListInsuranceProviders {\n    allInsuranceProviders {\n      edges {\n        node {\n          id\n          slug\n          niceName\n          mcsPartner {\n            slug\n            niceName\n          }\n        }\n      }\n    }\n  }\n"): (typeof documents)["\n  query ListInsuranceProviders {\n    allInsuranceProviders {\n      edges {\n        node {\n          id\n          slug\n          niceName\n          mcsPartner {\n            slug\n            niceName\n          }\n        }\n      }\n    }\n  }\n"];
/**
 * The graphql function is used to parse GraphQL queries into a document that can be used by GraphQL clients.
 */
export function graphql(source: "\n  mutation SubmitIntakeForm($input: IntakeSubmitInputType!) {\n    intakeFormSubmit(input: $input) {\n      graphqlMemberId\n    }\n  }\n"): (typeof documents)["\n  mutation SubmitIntakeForm($input: IntakeSubmitInputType!) {\n    intakeFormSubmit(input: $input) {\n      graphqlMemberId\n    }\n  }\n"];
/**
 * The graphql function is used to parse GraphQL queries into a document that can be used by GraphQL clients.
 */
export function graphql(source: "\n  mutation CreatePhiFileReference($input: CreatePhiFileReferenceInput!) {\n    phiFileReferenceCreate(input: $input) {\n      phiFileReference {\n        id\n        claimCode\n      }\n      s3UploadInfo {\n        uploadUrl\n      }\n    }\n  }\n"): (typeof documents)["\n  mutation CreatePhiFileReference($input: CreatePhiFileReferenceInput!) {\n    phiFileReferenceCreate(input: $input) {\n      phiFileReference {\n        id\n        claimCode\n      }\n      s3UploadInfo {\n        uploadUrl\n      }\n    }\n  }\n"];

export function graphql(source: string) {
  return (documents as any)[source] ?? {};
}

export type DocumentType<TDocumentNode extends DocumentNode<any, any>> = TDocumentNode extends DocumentNode<  infer TType,  any>  ? TType  : never;